// Module
var code = "<div class=\"circle-pager\"> <span class=\"circle pointer\" ng-repeat=\"circle in circles\" ng-click=\"onClick()($index)\" ng-class=\"{'active': currentPage === $index + 1 }\"> </span></div>";
// Exports
module.exports = code;